import { useDispatch } from 'react-redux';
import { Button } from 'reactstrap';
import intl from 'react-intl-universal';

import Page from 'components/Page';
import PageHeader from 'components/PageHeader';
import PageFooter from 'components/PageFooter';
import { closeForm } from 'modules/forms/actions/form.actions';
import FormResultBlock from 'modules/forms/components/FormResultBlock';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { signOutPatient } from 'modules/auth/actions/auth.actions';

const FormDisqualification = (): JSX.Element => {
  const dispatch = useDispatch();
  const location = useTypedSelector(state => state.app.location);

  const onClose = () => {
    dispatch(closeForm());
  };

  const onComplete = () => {
    dispatch(signOutPatient());
  };

  return (
    <Page>
      <PageHeader isComplete />
      <div className="page-content">
        <main id="page-main-scrollable" className="page-main">
          <FormResultBlock title="Thank you for answering our questions!" color="error">
            At this time, based on your responses, we do not recommend this treatment.
            <br />
            <br />
            If you have additional questions please feel free to contact us.
          </FormResultBlock>
        </main>

        {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          !!window.ReactNativeWebView && !location && (
            <PageFooter>
              <Button color="primary" type="button" block onClick={onClose}>
                {intl.get('button.close')}
              </Button>
            </PageFooter>
          )
        }
        {!!location && (
          <PageFooter>
            <Button color="primary" type="button" block onClick={onComplete}>
              {intl.get('forms.nextPatient')}
            </Button>
          </PageFooter>
        )}
      </div>
    </Page>
  );
};

export default FormDisqualification;
